import styled from "styled-components";

const HeaderWrapper = styled.header`
    text-align: center;
`;

const AppBrand = styled.div`
    color: white;
    min-height: 5rem;
    font-size: 3rem;
    font-weight: 900;
    padding-top: 2%;
`;

export { HeaderWrapper, AppBrand };
